import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Router } from "@/app/Router";
import { initAuth } from "@/stores/session";
import "./index.css";

initAuth();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: (failureCount, error) => {
        // Un 401 o un 403 no mejoran reintentando: o falta sesion o falta rol.
        const code = (error as { code?: string })?.code;
        if (code === "42501" || code === "PGRST301") return false;
        return failureCount < 2;
      },
      refetchOnWindowFocus: true,
    },
  },
});

const root = document.getElementById("root");
if (!root) throw new Error("Falta #root en index.html");

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <Router />
    </QueryClientProvider>
  </StrictMode>,
);
